// Función para formatear la fecha
import dayjs from "dayjs";
import { ref, computed, onMounted, onUnmounted } from 'vue';
import relativeTime from "dayjs/plugin/relativeTime";

// Extender dayjs con relativeTime solo una vez
dayjs.extend(relativeTime);

export const formatDate = (date, format = 'DD/MM/YYYY HH:mm') => {

    //vaida si la fecha es valida
    if (!date || !dayjs(date).isValid()) {
        return 'Fecha inválida';
    }

    //retorna la fecha formateada
    return dayjs(date).format(format);
};

// formatear para guardar en mongo
export const formatISODate = (date) => {
    return dayjs(date).toISOString();
};

// Helper function to get human-readable time difference
export const timeDifference = (date) => {
    return dayjs(date).fromNow();
};

export const useTimeDifference = (date) => {

    // Reactive reference to hold the current time
    const currentTime = ref(dayjs());

    // Function to update the current time
    const updateCurrentTime = () => {
        currentTime.value = dayjs();
    };

    // Set up a timer to update currentTime every minute
    let timer = null;

    onMounted(() => {
        // Initialize the current time
        updateCurrentTime();
        // Set the interval to update every minute (60000 ms)
        timer = setInterval(updateCurrentTime, 60000);
    });

    onUnmounted(() => {
        // Clear the interval when the component is unmounted
        if (timer) {
            clearInterval(timer);
        }
    });

    // Computed property to calculate the human-readable time difference
    const humanReadableTime = computed(() => {
        return dayjs(date).from(currentTime.value);
    });

    return humanReadableTime;
};